<template>
  <div class="" :class="{ hasTags: productTags.length !== 0 }">
    <div class="imageWrapper">
      <template v-if="productTags" class="tags">
        <div
          v-for="(tag, i) in productTags"
          :key="(i += 1)"
          class="tag trans button-green"
          :class="{ activated: i - 1 === activatedTag }"
          :style="{
            left: tag.coords.split(',')[0] * 100 + '%',
            bottom: tag.coords.split(',')[1] * 100 + '%',
          }"
          @click="handleTagClick(i - 1)"
        />
      </template>
      <template>
        <img v-show="isLoaded" :src="imgSrc" @load="loaded" />
        <div v-show="!isLoaded" class="placeholder">
          <loader-static />
        </div>
      </template>
    </div>
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(tag, i) in productTags" :key="(i += 1)">
        <div class="mb-10 slide-container" :class="{ selected: activatedTag === i - 1 }" @click="swiperClick(i - 1)">
          <favorite-button
            class="favorite-button"
            :id="getTagProductId(tag)"
            :is-fav="isTaggedProductFavorite(tag)"
            :is-product="true"
          />
          <img v-if="tag.product_thumbnail_url" :src="tag.product_thumbnail_url" class="product-image" alt="" />
          <div v-else class="image-placeholder icon-upload-image object-fit-cover width-100" style="height: 206px" />
          <div class="product-name truncate">
            {{ tag.title }}
          </div>
          <div class="product-price">${{ tag.wholesale_price }}</div>

          <bulletin-button
            class="quick-shop-button"
            variant="green"
            no-min-width
            @click="(event) => handleQuickShopClick(event, tag)"
          >
            Quick Shop
          </bulletin-button>
        </div>
      </swiper-slide>

      <div slot="button-prev" class="swiper-button-prev" />
      <div slot="button-next" class="swiper-button-next" />
    </swiper>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";
.swiper-container {
  border-radius: 0px 0px 6px 6px;
  .swiper-button-prev,
  .swiper-button-next {
    color: white;
    opacity: 1;
    top: 103px;
    background: black;
    width: 40px;
    height: 40px;
  }
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 20px;
    font-weight: bold;
  }
}

.swiper-slide {
  .slide-container {
    position: relative;
    opacity: 0.2;
    cursor: pointer;
    font-size: 0;

    &.selected,
    &:hover {
      opacity: 1;
    }

    &:hover {
      .quick-shop-button {
        display: block;
      }

      @include respond-to("small") {
        .quick-shop-button {
          display: none !important;
        }
      }
    }

    .favorite-button {
      position: absolute;
      top: 4px;
      right: 4px;
      transform: scale(0.8);
    }

    .quick-shop-button {
      position: absolute;
      top: 150px;
      left: 16px;
      right: 16px;
      display: none;
      width: calc(100% - 32px);
    }

    .product-image {
      height: 206px;
      width: 100%;
      object-fit: cover;
      border-radius: 4px;
      object-position: top;
    }

    .product-name,
    .product-price {
      font-size: 16px;
      font-family: NHaasGroteskDSPro-55Rg;
    }
    .product-name {
      margin-top: 16px;
      margin-bottom: 8px;
    }
  }
}

.imageWrapper {
  position: relative;
  user-select: none;
  margin-bottom: 16px;

  @include respond-to("small") {
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-bottom: 10px;

    img {
      border-radius: 0 !important;
    }
  }

  img {
    width: 100%;
    border-radius: 8px;
  }
  &.hasTags {
    > img {
      width: 100%;
      border-radius: 6px 6px 0 0;
    }
  }
  .tag {
    position: absolute;
    width: 25px;
    height: 25px;
    margin-top: -6px;
    margin-left: -6px;
    border-radius: 12px;
    cursor: pointer;
    background: white;
    border: 1px solid $color-grey;

    &.activated {
      background: $color-green;
      border: 1px solid black;
    }
  }
  .productDescriptionBox {
    width: 210px;
    position: absolute;
    padding: 11px;
    border: 1px solid black;
    background-color: white;
    top: 46px;
    right: 24px;
    .retailPrice {
      color: lightgray;
    }
  }
  .placeholder {
    width: 100%;
    padding-bottom: 120%;
  }
}
</style>

<script>
import InlineSvg from "vue-inline-svg";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SwiperCore, { Navigation } from "swiper";
import { mapGetters } from "vuex";
import utils from "../../services/utils";
import { breakPointsHelper } from "../../components/mixin/breakPointsHelpers";

SwiperCore.use([Navigation]);

export default {
  name: "PostImageWithProductCarousel",
  mixins: [breakPointsHelper],
  components: {
    InlineSvg,
    Swiper,
    SwiperSlide,
  },
  props: ["productTags", "imgSrc", "imgId", "postIndex", "post", "feedEvents"],
  data() {
    return {
      activatedTag: 0,
      description: null,
      isLoaded: false,
      hasAdminLink: false,
      slideToSpeed: 300,

      swiperOptions: {
        margin: 40,
        slidesPerView: 2,
        spaceBetween: window.innerWidth < 770 ? 16 : 24,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "hide",
        },
      },
      showNext: false,
      showPrev: false,
      top: 0,
    };
  },
  methods: {
    handleTagClick,
    clearActivated,
    loaded,
    handleTagCTAClick,
    swiperClick,
    handleQuickShopClick,
    productTagCTAClicked,
    productTagsRevealed,
    isTaggedProductFavorite,
    getTagProductId,
    navigateToPdpPage,
    urlFormatter: utils.urlSafeString,
  },
  computed: {
    ...mapGetters({
      favoriteProducts: "favoriteProductsState",
    }),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};

function loaded() {
  this.isLoaded = true;
}

function handleTagClick(currentPosition) {
  if (currentPosition !== this.activatedTag) {
    this.activatedTag = currentPosition;
    this.swiper.slideTo(this.activatedTag, this.slideToSpeed, true);
  }
}

function handleTagCTAClick() {
  const index = this.activatedTag - 1;
  this.productTagCTAClicked(index);
  this.$router.push(this.description.url);
}

function clearActivated() {
  this.activatedTag = 0;
  this.activatedDescriptionBox = null;
}

function swiperClick(clickIndex) {
  const newIndex = clickIndex;

  if (newIndex === this.activatedTag) {
    this.navigateToPdpPage(this.productTags[this.activatedTag]);
  }

  this.activatedTag = newIndex;
}

function handleQuickShopClick(event, tag) {
  event.stopPropagation();

  this.$ma.trackEvent({
    action: "Quickshop Click - Feed",
  });
  this.$eventBus.$emit("show-quick-shop-modal-by-id", tag.product_id ? tag.product_id : tag.url.split("/").pop());
}

function productTagCTAClicked(tagIndex) {
  const post = this.$data.posts.edges[this.postIndex].node,
    tag = post.media.productTags[tagIndex];

  this.feedEvents?.track(
    "PRODUCT_TAG_CTA_CLICKED",
    {
      ...post,
      index: this.postIndex,
    },
    {
      tag_type: tag.tag_type,
      // eslint-disable-next-line no-prototype-builtins
      parent_category: tag.hasOwnProperty("parent_category") ? tag.parent_category : "",
    }
  );
}

function productTagsRevealed(postIndex, tagIndex) {
  const tag = this.post.media.productTags[tagIndex];

  this.feedEvents?.track(
    "PRODUCT_TAG_VIEWED",
    {
      ...post,
      index: postIndex,
    },
    {
      tag_type: tag.tag_type,
      // eslint-disable-next-line no-prototype-builtins
      parent_category: tag.hasOwnProperty("parent_category") ? tag.parent_category : "",
    }
  );
}

function getTagProductId(tag) {
  return tag.product_id || tag.url.split("/").pop();
}

function isTaggedProductFavorite(tag) {
  return this.favoriteProducts.includes(this.getTagProductId(tag));
}

function navigateToPdpPage(tag) {
  this.$router.push({
    name: "productDetails",
    params: {
      productName: this.urlFormatter(tag.title),
      productId: this.getTagProductId(tag),
    },
  });
}
</script>
